


























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({ name: 'v-label' })
export default class VLabel extends Vue {
    /**
     * Extra tooltip to display
     */
    @Prop({ type: String })
    tooltip?: string

    /**
     * Error message to display
     */
    @Prop({ type: String })
    error?: string
}
